<ng-template #template>
    @let saveFailedTitle = "saveFailedTitle" | t;
    <div class="modal-header" data-uiid="generic-form-editor">
        @if (config) {
            <h5 class="modal-title pull-left">
                {{
                    (editEnabled ? "editTitle" : "viewTitle")
                        | t: { name: (config.name | lowercase) }
                }}
            </h5>
        }
    </div>
    @if (showHeaderMessage) {
        <div class="action-bar-header">
            <div
                [class.error-message]="headerType === GenericEditWindowHeaderType.Error"
                [class.warning-message]="headerType === GenericEditWindowHeaderType.Warning"
                [class.info-message]="headerType === GenericEditWindowHeaderType.Info"
            >
                {{ headerMessage }}
            </div>
        </div>
    }
    @if (row) {
        <div class="modal-body cerrix-control-sm container-fluid">
            <div class="row">
                @for (field of FieldsToEdit; track field) {
                    <div class="form-group col-{{ field.editorWidth ? field.editorWidth : '12' }}">
                        <generic-field-editor
                            [row]="row"
                            [field]="field"
                            [editEnabled]="editEnabled"
                            [additionalData]="additionalData"
                            (valueChanged)="fieldValueChanged()"
                        ></generic-field-editor>
                    </div>
                }
            </div>
        </div>
    }
    <div class="modal-footer">
        @if (config?.editWindowButtons && showEditButtons) {
            @for (btn of config.editWindowButtons; track btn) {
                <button
                    [class]="btn.class ? btn.class : 'btn btn-secondary'"
                    [attr.data-uiid]="btn.uiid"
                    (click)="customButtonClicked(btn)"
                >
                    @if (btn.icon) {
                        <i [class]="btn.icon"></i>
                    }
                    <span class="ms-2">{{ btn.text }}</span>
                </button>
            }
            <div class="custom-button-seperator"></div>
        }
        @if (editEnabled) {
            <button
                data-uiid="genericdialog-applybutton"
                type="button"
                class="btn btn-primary"
                (click)="apply(saveFailedTitle)"
            >
                {{ "applyButton" | t }}
            </button>
        }
        <button type="button" class="btn btn-secondary" (click)="close()">{{
            "closeButton" | t
        }}</button>
    </div>
</ng-template>
